export const todayGroupHeader = "rOd";
export const yesterdayGroupHeader = "sOd";
export const thisWeekGroupHeader = "tOd";
export const lastWeekGroupHeader = "uOd";
export const thisMonthGroupHeader = "vOd";
export const lastMonthGroupHeader = "wOd";
export const olderGroupHeader = "xOd";
export default {todayGroupHeader,yesterdayGroupHeader,thisWeekGroupHeader,lastWeekGroupHeader,thisMonthGroupHeader,lastMonthGroupHeader,olderGroupHeader};